import { Pipe, PipeTransform } from '@angular/core';
import { INetworkMidLevelFilterOption } from 'Src/ng2/network/network-mid-level/network-mid-level.models';

@Pipe({ name: 'superFilterPill' })
export class SuperFilterPill implements PipeTransform {
  transform(
    { filter_values, filter_type }: INetworkMidLevelFilterOption,
    selection: Array<string> | string,
  ): Array<string> | string {
    if (filter_type === 'dropdown') return selection ? selection : 'All';
    if (filter_type === 'multiselect') {
      if (!selection.length) return 'None';
      else if (selection.length === filter_values.length) return 'All';
      else if (filter_values.length - selection.length === 1) return 'All but 1';
      else if (selection.length === 1) return selection as Array<string>;
      else return `${selection.length} selected`;
    }
  }
}
